import { Dropdown } from "primereact/dropdown";
import type { SelectItem } from "primereact/selectitem";
import SlidersHIcon from "../../../../components/icons/SlidersHIcon";

import { useWrapAsync } from "@paroicms/front-app-log";
import { useEffect, useState } from "react";
import { apiRequestWrapper } from "../../../../api/shared/http-client";
import "./OurDropdown.scss";

export default function OurDropdown<T>({
  selectedOption,
  leftIcon,
  filter,
  placeholder,
  className,
  onChange,
  initialOptions,
  onSearch,
  invalid = false,
  alwaysTriggerOnChange = false,
  disabled = false,
  onOptionItemClick,
  rowData,
}: {
  selectedOption?: T;
  filter?: boolean;
  leftIcon?: boolean;
  placeholder?: string;
  className?: string;
  onChange?(value: T): void;
  initialOptions?: SelectItem[];
  onSearch?(val: string): Promise<SelectItem[]>;
  invalid?: boolean;
  alwaysTriggerOnChange?: boolean;
  disabled?: boolean;
  // TODO: remove these two lines and use form above for edit
  onOptionItemClick?(rowData: any): void;
  rowData?: any;
}) {
  const wrapAsync = useWrapAsync();
  const [options, setOptions] = useState<SelectItem[]>([]);
  const [loading, setLoading] = useState(false);

  const onFilter = wrapAsync(async (val: string) => {
    if (val === "" || !onSearch) return;
    await handleSearchReference(val);
  });
  const handleSearchReference = async (val: string) => {
    if (!onSearch) return;
    setLoading(true);
    await apiRequestWrapper(async () => {
      const items = await onSearch(val);
      setOptions([...items]);
    });
    setLoading(false);
  };

  useEffect(() => {
    if (initialOptions) {
      setOptions([...initialOptions]);
    }
  }, [initialOptions, selectedOption]);

  const handleOptionSelect = (value: T) => {
    if (alwaysTriggerOnChange) {
      onChange?.(value);
    } else {
      if (value !== selectedOption) {
        onChange?.(value);
      }
    }
  };

  return (
    <div className={`OurDropdown${leftIcon ? " withIcon" : ""}${className ? ` ${className}` : ""}`}>
      {leftIcon && (
        <div className="OurDropdown-icon">
          <SlidersHIcon />
        </div>
      )}
      <Dropdown
        className="OurDropdown-primereactDropdown"
        value={selectedOption}
        onChange={(e) => {
          onOptionItemClick?.(rowData);
          setTimeout(() => {
            handleOptionSelect(e.value);
          }, 200);
        }}
        itemTemplate={(item) => {
          return (
            <button
              type="button"
              className="OurDropdown-item"
              onClick={() => {
                onOptionItemClick?.(rowData);
                setTimeout(() => {
                  handleOptionSelect(item.value);
                }, 200);
              }}
              onMouseDown={(e) => {
                // Ensure the click is captured even for selected items
                e.preventDefault();
                onOptionItemClick?.(rowData);
                setTimeout(() => {
                  handleOptionSelect(item.value);
                }, 200);
              }}
            >
              {item.label}
            </button>
          );
        }}
        options={options}
        optionValue="value"
        optionLabel="label"
        checkmark={true}
        highlightOnSelect={false}
        filter={filter}
        onFilter={(ev) => onFilter(ev.filter)}
        placeholder={placeholder}
        emptyMessage="Pas de choix disponibles"
        emptyFilterMessage="Aucun résultat"
        loading={loading}
        invalid={invalid}
        disabled={disabled}
      />
    </div>
  );
}
